
import { ref, onMounted, onBeforeUnmount } from 'vue'
import { getAuthToken, getUserType } from '@/utils/auth'
import { App, UserType } from '@/common/constant'
import { redirectToApp } from '@/common/common-fn'
import MsDrawer from '@/components/drawer'
import { on, off, globalEvents } from '@/utils/event-bus'
const HELP_BASE_URL = 'https://emishelp.misa.vn/kb/'

export default {
  components: {
    MsDrawer
  },

  beforeRouteEnter (to: any, from: any, next: any) {
    let redirect = false
    const token = getAuthToken()
    const userType = getUserType()
    const currentApp = window.__appName

    switch (currentApp) {
      case App.Account:
        if (token) {
          redirect = !to.meta.notRedirect

          if (!redirect) {
            break
          }

          if (userType === UserType.Teacher) {
            redirectToApp(App.Teacher)
          } else if (userType === UserType.Student) {
            redirectToApp(App.Student)
          }
        }
        break
      case App.Student:
        if (userType === UserType.Teacher) {
          redirect = true
          redirectToApp(App.Teacher)
        }
        break
      case App.Teacher:
        if (userType === UserType.Student) {
          redirect = true
          redirectToApp(App.Student)
        }
        break
    }
    !redirect && next()
  },

  setup () {
    const drawerVisible = ref(false)
    const helpSrc = ref('#')
    const showHelpDrawer = (helpID: string) => {
      helpSrc.value = `${HELP_BASE_URL}${helpID || ''}/?inside=showiframe`
      drawerVisible.value = true
    }

    onMounted(() => {
      on(globalEvents.ShowHelp, showHelpDrawer)
    })

    onBeforeUnmount(() => {
      off(globalEvents.ShowHelp, showHelpDrawer)
    })

    return {
      drawerVisible,
      helpSrc
    }
  }
}
